module.exports = __webpack_public_path__ + "img/result_txt_f.490c0283.png";